import { ReactNode, useState } from 'react';
import { styled } from '../../../../theme/stitches.config';

// Components
import { SMPText } from '../../../index';

const TooltipContainer = styled.withConfig({ componentId: 'CommonWidget', displayName: 'TooltipContainer' })('div', {
  position: 'relative',
});

const StandingsTooltipBox = styled.withConfig({
  componentId: 'CommonWidget',
  displayName: 'StandingsTooltipBox',
})('div', {
  position: 'absolute',
  bottom: 'calc(100% + 8px + 2px)',
  left: '50%',
  display: 'none',
  borderRadius: '4px',
  backgroundColor: '$standingsTooltipContainerPrimaryBgColor',
  color: '$standingsTooltipContainerTextColor',
  whiteSpace: 'nowrap',
  fontSize: '12px',
  zIndex: '1050',
  cursor: 'pointer',
  transform: 'translateX(-50%)',

  '&::after': {
    content: '""',
    position: 'absolute',
    top: '100%',
    left: '50%',
    border: '8px solid transparent',
    borderTopColor: '$standingsTooltipContainerPrimaryBgColor',
    transform: 'translateX(-50%)',
    pointerEvents: 'none',
  },
});

const TooltipBox = styled.withConfig({ componentId: 'CommonWidget', displayName: 'TooltipBox' })('div', {
  zIndex: '101',
  position: 'absolute',
  background: '$tooltipBackgroundColor',
  color: '#ffffff',
  padding: '$1',
  borderRadius: '$2',
  top: '-$1',
  // opacity: '0.8',
  transform: 'translate(-80%, -100%)',
  transition: 'display 0.5s',
  variants: {
    display: {
      none: {
        display: 'none',
      },
      block: {
        display: 'block',
      },
    },
  },
  defaultVariants: {
    display: 'none',
  },
});

export interface ITooltipProps {
  text: string;
  children: ReactNode;
  overlineText?: string;
  standingsForm?: boolean;
}

export const Tooltip = ({ children, text, overlineText, standingsForm }: ITooltipProps) => {
  const [show, setShow] = useState(false);

  const handleMouseEnter = () => setShow(true);
  const handleMouseLeave = () => setShow(false);

  return (
    <TooltipContainer>
      {standingsForm ? (
        <StandingsTooltipBox
          style={{
            padding: '10px 10px',
            display: show ? 'flex' : 'none',
            flexDirection: 'column',
            gap: '10px',
          }}
        >
          <SMPText variant='tooltipText' size='2_5' css={{ textAlign: 'center', fontWeight: '700' }}>
            {overlineText}
          </SMPText>
          <SMPText variant='tooltipText' size='2_5' css={{ whiteSpace: 'nowrap' }}>
            {text}
          </SMPText>
        </StandingsTooltipBox>
      ) : (
        <TooltipBox display={show ? 'block' : 'none'}>
          <SMPText variant='tooltip' size='2' css={{ textAlign: 'center' }}>
            {overlineText}
          </SMPText>
          <SMPText variant='tooltip' size='3' css={{ whiteSpace: 'nowrap' }}>
            {text}
          </SMPText>
        </TooltipBox>
      )}

      <div
        style={{ top: standingsForm ? '5px' : undefined, position: 'relative' }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </div>
    </TooltipContainer>
  );
};
